import React, { Fragment, useEffect } from 'react';
import {
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  FormGroup,
  Switch,
  FormControlLabel,
  Grid,
  TextField,
} from '@mui/material';
import FilterAccordian from '../filterAccordian';
import Breadcrumb from '../common/breadcrumb';
import { userRequest } from '../../auth/requestMethods';
import MenuBook from '@mui/icons-material/MenuBook';
import { randomId } from '@mui/x-data-grid-generator';
import { Modal, ModalHeader, ModalBody, Alert } from 'reactstrap';
import { toast } from 'react-toastify';
import CustomTable from '../tables/MuiDataGrid';
import * as Yup from 'yup';
import { useForm, Controller } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { AlertCircle } from 'react-feather';
import { useLocation } from 'react-router-dom';

const Manage = ({ history }) => {
  useEffect(() => {
    document.title = 'PFSA | Menu Details';
  }, []);
  const location = useLocation();

  const days = ['Mo', 'Tu', 'We', 'Th', 'Fr'];
  const [perPage, setPerPage] = React.useState(10);
  const [page, setPage] = React.useState(1);
  const [dataIsFetching, setDataIsFetching] = React.useState(true);
  const [editMode, setEditMode] = React.useState(false);
  const [tableData, setTableData] = React.useState({ count: 0, menus: [] });
  const [modalState, setModalState] = React.useState({
    update: false,
    open: false,
  });
  const [searchInput, setSearchInput] = React.useState({
    id: 'Select',
    day_of_week: 'All',
    sku_type: 'All',
  });
  const [filterOptions, setFilterOptions] = React.useState({
    menus: [],
    skuTypes: [],
    uoms: [],
    menuDays: [],
  });

  React.useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const menuId = searchParams.get('menuId');

    if (menuId) {
      const menu = filterOptions.menus.find((obj) => obj.id === Number(menuId));

      if (menu) {
        setSearchInput((prevState) => ({
          ...prevState,
          id: menu.id,
        }));
      }
    }
  }, [location.search, filterOptions.menus]);

  const {
    register,
    handleSubmit,
    watch,
    reset,
    control,
    trigger,
    getValues,
    // formState,
    formState: { errors, isSubmitted },
  } = useForm({
    resolver: yupResolver(validationSchema),
    defaultValues,
  });

  const values = getValues();

  React.useEffect(() => {
    trigger();
    const subscription = watch((value, { name }) => trigger(name));
    return () => subscription.unsubscribe();
  }, [watch, trigger]);

  React.useEffect(() => {
    bulkAxios(['/menus/names', '/sku-types/names', '/unit-of-measures'])
      .then((all) => {
        setFilterOptions((pr) => ({
          ...pr,
          menus: all[0].menus,
          skuTypes: all[1].skuTypes,
          uoms: all[2].unitOfMeasures,
        }));
      })
      .catch((error) => console.log(error));
  }, []);

  React.useEffect(() => {
    setDataIsFetching((current) => {
      if (!current) return true;
    });
    let link = '';
    if (searchInput.id) {
      link = `/menus/details?per_page=${perPage}&page=${page}&${buildQuery()}`;
    } else if (window.location.search) {
      link = `/menus/details${window.location.search}&per_page=${perPage}&page=${page}`;
    }
    link &&
      userRequest()
        .get(link)
        .then(({ data }) => {
          console.log(data);
          setTableData({ count: data.total, menus: data.menus });
          setDataIsFetching(false);
        })
        .catch((response) => {
          console.log(response);
          setDataIsFetching(false);
        });
  }, [perPage, page]);

  React.useEffect(() => {
    const fetchItems = async () => {
      console.log(searchInput);
      try {
        setDataIsFetching(true);

        const queryString = buildQuery();
        let urls = [`/menus/details?per_page=${perPage}&page=${page}&${queryString}`];
        searchInput.id && urls.push(`/menu-vs-menu-days?menu_id=${searchInput.id}`);

        const all = await bulkAxios(urls);

        setTableData({ count: all[0].total, menus: all[0].menus });

        if (all.length > 1) {
          setFilterOptions((prevFilterOptions) => ({
            ...prevFilterOptions,
            menuDays: all[1]?.menuVsMenuDays,
          }));
        }
      } catch (error) {
        console.error(error);
        setTableData({ count: 0, menus: [] });
      } finally {
        setDataIsFetching(false);
      }
    };

    fetchItems();
  }, [searchInput]);

  function bulkAxios(urls = null) {
    if (!urls) return urls;

    let promises = urls.map((req) =>
      userRequest()
        .get(req)
        .then(({ data }) => {
          return data;
        })
        .catch((error) => {
          console.log(error);
          return null;
        })
    );

    return Promise.all(promises);
  }

  function buildQuery(foundFilter = null) {
    return Object.entries(searchInput)
      .map(([key, value]) => {
        if (value !== '') {
          if (foundFilter) foundFilter.push(key);
          let tempKey = key;
          let tempValue = value;
          if (key === 'id') {
            if (value === 'Select') {
              tempKey = '';
              tempValue = '';
            }
          }
          if (key === 'day_of_week') {
            if (value === 'All') {
              tempKey = '';
              tempValue = '';
            }
          }
          if (key === 'sku_type') {
            if (value === 'All') {
              tempKey = '';
              tempValue = '';
            }
          }

          return encodeURIComponent(tempKey) + '=' + encodeURIComponent(tempValue);
        }
        return '';
      })
      .filter((Q) => !!Q)
      .join('&');
  }

  const onChangeInput = (e, val, name = null) => {
    if (name) {
      setSearchInput({ ...searchInput, [name]: val });
    } else {
      setSearchInput({ ...searchInput, [e.target.name]: e.target.value });
    }
  };

  //fetch data only when the searhinput state changes

  function getAvailableSkuTypes() {
    let sts = filterOptions.skuTypes;
    if (!tableData.menus.length) return sts;

    return sts.filter(({ id }) => {
      let index = tableData.menus.findIndex(
        (rw) => rw.sku_type === id && rw.day_of_week === values.day_of_week && rw.id !== modalState.update
      );
      return index < 0;
    });
  }

  function onSave({ day_of_week, ...form }) {
    const id = modalState.update;
    toast.info(`${id ? 'Updating...' : 'Creating...'}`, {
      isLoading: true,
      position: 'bottom-center',
      autoClose: 5000,
      theme: 'colored',
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      toastId: 'create',
    });
    let api = id ? `/menu-day-vs-sku-types/update/${id}` : '/menus/details';
    userRequest()
      .post(api, {
        ...form,
        menu_day: filterOptions.menuDays.find((day) => day_of_week == day.day_of_week)?.id,
      })
      .then(({ data }) => {
        toast.dismiss('create');
        toast.success(`Successfully ${id ? 'updated' : 'created'}`, {
          position: 'bottom-center',
          autoClose: 5000,
          closeOnClick: true,
          draggable: true,
        });
        console.log(data);
        let menus = [];
        if (id) {
          menus = tableData.menus.map((m) => {
            let uom = filterOptions.uoms.find((u) => u.id === form.unit_of_measure)?.display_unit;
            let sku_type_name = filterOptions.skuTypes.find((st) => st.id === form.sku_type)?.display_name;

            if (m.id === id)
              return {
                ...data.menuDayVsSkuType,
                day_of_week,
                uom,
                sku_type_name,
              };
            else return m;
          });
        } else {
          // TODO : verify filter conditions,  meetFilterConditions(holiday, false)
          menus = [...tableData.menus, data.menu];
        }
        setTableData((prev) => ({
          menus,
          count: id ? prev.count : prev.count + 1,
        }));
        setModalState({ open: false, update: 0 });
      })
      .catch(({ response }) => {
        toast.dismiss('create');
        toast.error(response.data.message, {
          position: 'bottom-center',
          autoClose: 5000,
          closeOnClick: true,
          draggable: true,
        });
      });
  }

  function getFilters() {
    return Object.entries(searchInput)
      .map(([key, value]) => {
        if (value !== '') {
          if (key === 'id') {
            if (value === 'Select') {
              return [];
            } else {
              return `Menu:${filterOptions.menus.find((x) => x.id === value)?.display_name}`;
            }
          } else if (key === 'day_of_week') {
            if (value === 'All') {
              return [];
            } else {
              return `Day:${days[value - 1]}`;
            }
          } else if (key === 'sku_type') {
            if (value === 'All') {
              return [];
            } else {
              return `SKU Type:${filterOptions.skuTypes.find((x) => x.id === value)?.display_name}`;
            }
          }
        }
        return undefined;
      })
      .filter((x) => x !== undefined && x.length !== 0);
  }

  const actionMethods = {
    width: 100,
    toggleEdit: (row) => {
      reset(
        Object.keys(defaultValues).reduce((pr, ky) => {
          pr[ky] = row[ky];
          return pr;
        }, {})
      );
      setModalState({ open: true, update: row.id });
    },
    toggleDelete: (row) => {
      userRequest()
        .post(`/menu-day-vs-sku-types/delete/${row.id}`)
        .then(({ data }) =>
          setTableData((prev) => ({
            count: prev.count - 1,
            menus: prev.menus.filter((m) => m.id !== row.id),
          }))
        )
        .catch((error) => console.log(error));
    },
  };

  const columns = [
    {
      field: 'day_of_week',
      headerName: 'Day',
      valueFormatter: ({ value }) => days[value - 1] || '',
      flex: 1,
    },
    {
      field: 'sku_type_name',
      headerName: 'SKU Type',
      flex: 1,
    },
    {
      field: 'quantity_in_unit_of_measure',
      headerName: 'Qty',
      type: 'number',
      flex: 1,
    },
    {
      field: 'uom',
      headerName: 'UOM',
      flex: 1,
    },
  ];

  return (
    <Fragment>
      <Breadcrumb icon={<MenuBook />} title="Manage" parent="Menu Details" />

      <div className="container-fluid">
        <FilterAccordian filters={getFilters()}>
          <form className="theme-form" noValidate="">
            <div className="form-group row mx-0">
              <FormControl>
                <InputLabel>Menu</InputLabel>
                <Select
                  name="id"
                  value={searchInput.id}
                  onChange={(e) => onChangeInput(e, e.target.value, 'id')}
                  label="Menu"
                  style={{
                    fontStyle: searchInput.id === 'Select' ? 'italic' : 'normal',
                  }}
                >
                  <MenuItem value={'Select'} style={{ fontStyle: 'italic' }}>
                    Select
                  </MenuItem>
                  {filterOptions.menus.map((m) => (
                    <MenuItem key={m.id} value={m.id}>
                      {m.display_name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </div>
            <div className="form-group row mx-0">
              <FormControl>
                <InputLabel>Day</InputLabel>
                <Select
                  name="day_of_week"
                  value={searchInput.day_of_week}
                  onChange={(e) => onChangeInput(e, e.target.value, 'day_of_week')}
                  labelId="demo-simple-select-helper-label"
                  id="demo-simple-select-helper"
                  label="Day"
                  style={{
                    fontStyle: searchInput.day_of_week === 'All' ? 'italic' : 'normal',
                  }}
                >
                  <MenuItem value={'All'} style={{ fontStyle: 'italic' }}>
                    All
                  </MenuItem>
                  {days.map((day, i) => (
                    <MenuItem key={i} value={i + 1}>
                      {day}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </div>
            <div className="form-group row mx-0">
              <FormControl>
                <InputLabel id="demo-simple-select-helper-label">SKU Type</InputLabel>
                <Select
                  name="sku_type"
                  value={searchInput.sku_type}
                  onChange={(e) => onChangeInput(e, e.target.value, 'sku_type')}
                  labelId="demo-simple-select-helper-label"
                  id="demo-simple-select-helper"
                  label="SKU Type"
                  style={{
                    fontStyle: searchInput.sku_type === 'All' ? 'italic' : 'normal',
                  }}
                >
                  <MenuItem value={'All'} style={{ fontStyle: 'italic' }}>
                    All
                  </MenuItem>
                  {filterOptions.skuTypes.map((m) => (
                    <MenuItem key={m.id} value={m.id}>
                      {m.display_name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </div>
          </form>
        </FilterAccordian>
      </div>
      {searchInput.id === '' || searchInput.id === 'Select' ? (
        <Alert className="m-15 d-flex gap-3" color="secondary dark">
          <AlertCircle />
          <p>The menu should be selected in the filters before menu details can be created</p>
        </Alert>
      ) : (
        <button
          onClick={() => {
            setModalState({ open: true, update: false });
            reset(defaultValues);
          }}
          className="btn btn-secondary m-15"
          type="submit"
        >
          <i className="fa fa-plus fa-xl" aria-hidden="true"></i>
        </button>
      )}

      <Modal
        isOpen={modalState.open}
        toggle={() => {
          setModalState({ open: false, update: false });
        }}
        size="lg"
        centered={true}
      >
        <ModalHeader
          toggle={() => {
            setModalState({ open: false, update: false });
          }}
        >
          {modalState.update ? 'Edit' : 'Create'} Menu Details
        </ModalHeader>
        <ModalBody>
          {/* {searchInput.id === '' || searchInput.id === 'Select' && (
            <Alert className="m-15 d-flex gap-3" color="secondary dark">
              <AlertCircle />
              <p>
                The menu should be selected in the filters and searched before menu
                details can be created
              </p>
            </Alert>
          )} */}
          <form className="theme-form" onSubmit={handleSubmit(onSave)}>
            <div className="form-group row mx-0">
              <Controller
                control={control}
                name="day_of_week"
                defaultValue={''}
                render={({ field }) => (
                  <FormControl error={!!(errors.day_of_week?.message && isSubmitted && getValues().day_of_week === '')}>
                    <InputLabel>Day of week</InputLabel>
                    <Select
                      name={field.name}
                      value={field.value}
                      onBlur={field.onBlur}
                      onChange={(e) => {
                        field.onChange(e.target.value);
                      }}
                      label="Day of week"
                    >
                      <MenuItem value="">Select </MenuItem>
                      {days.map((d, i) => (
                        <MenuItem key={i} value={i + 1}>
                          {d}
                        </MenuItem>
                      ))}
                    </Select>

                    {/* <FormHelperText>{errors.day_of_week?.message && isSubmitted ? errors.day_of_week.message : ''}</FormHelperText> */}
                  </FormControl>
                )}
              />
            </div>
            <div className="form-group row mx-0">
              <Controller
                control={control}
                name="sku_type"
                defaultValue={''}
                render={({ field }) => (
                  <FormControl error={!!(errors.sku_type?.message && isSubmitted && getValues().sku_type === '')}>
                    <InputLabel>SKU Type</InputLabel>
                    <Select
                      name={field.name}
                      value={field.value}
                      onBlur={field.onBlur}
                      onChange={(e) => {
                        field.onChange(e.target.value);
                      }}
                      label="SKU Type"
                    >
                      <MenuItem value={''}>- Select -</MenuItem>
                      {getAvailableSkuTypes().map((st, i) => (
                        <MenuItem key={i} value={st.id}>
                          {st.display_name}
                        </MenuItem>
                      ))}
                    </Select>
                    {/* <FormHelperText>{errors.sku_type?.message && isSubmitted ? errors.sku_type.message : ''}</FormHelperText> */}
                  </FormControl>
                )}
              />
            </div>

            <div className="form-group d-flex gap-4 flex-wrap row mx-0">
              <TextField
                value={values.quantity_in_unit_of_measure}
                sx={{ flex: 2 }}
                type="number"
                label="Quantity"
                variant="outlined"
                {...register(`quantity_in_unit_of_measure`)}
                // helperText={errors.quantity_in_unit_of_measure?.message && isSubmitted ? errors.quantity_in_unit_of_measure.message : ''}
                error={
                  !!(
                    errors.quantity_in_unit_of_measure?.message &&
                    isSubmitted &&
                    getValues().quantity_in_unit_of_measure === ''
                  )
                }
                inputProps={{
                  style: {
                    color: 'black',
                  },
                }}
              />
              <Controller
                control={control}
                name="unit_of_measure"
                render={({ field }) => (
                  <FormControl
                    sx={{ flex: 6 }}
                    error={errors.unit_of_measure?.message && isSubmitted ? errors.unit_of_measure.message : ''}
                  >
                    <InputLabel>UOM</InputLabel>
                    <Select
                      name={field.name}
                      value={field.value}
                      onBlur={field.onBlur}
                      onChange={(e) => {
                        field.onChange(e.target.value);
                      }}
                      label="UOM"
                    >
                      <MenuItem value={''}>- Select -</MenuItem>
                      {filterOptions.uoms.map((uom, i) => (
                        <MenuItem key={i} value={uom.id}>
                          {uom.display_unit}
                        </MenuItem>
                      ))}
                    </Select>
                    {/* <FormHelperText>
                    {errors.unit_of_measure?.message && isSubmitted ? errors.unit_of_measure.message : ''}
                    </FormHelperText> */}
                  </FormControl>
                )}
              />
            </div>

            <Grid item xs={12} marginBottom={3}>
              <div>
                <button
                  className="btn btn-primary me-1"
                  // disabled={!filterOptions.menuDays.length}
                  type="submit"
                >
                  {modalState.update ? 'Save' : 'Create'}
                </button>

                <button
                  onClick={() => {
                    setModalState({ open: false, update: 0 });
                  }}
                  className="btn btn-secondary"
                  type="button"
                >
                  Cancel
                </button>
              </div>
            </Grid>
          </form>
        </ModalBody>
      </Modal>
      <div className="container-fluid">
        <div className="d-flex justify-content-start my-2">
          <FormGroup>
            <FormControlLabel
              value={editMode}
              control={
                <Switch
                  onChange={() => {
                    setEditMode(!editMode);
                  }}
                />
              }
              label="Unlock Menu for editing"
              sx={{ margin: 0 }}
              labelPlacement="start"
            />
          </FormGroup>
        </div>
        <CustomTable
          rows={tableData.menus}
          actions={editMode ? actionMethods : { width: 100 }}
          columns={columns}
          setPageSize={setPerPage}
          setPage={setPage}
          getRowId={() => randomId()}
          rowCount={tableData.count}
          pageSize={perPage}
          loading={dataIsFetching}
          sortModel={[{ field: 'day_of_week', sort: 'asc' }]}
        />
      </div>
    </Fragment>
  );
};

const defaultValues = {
  day_of_week: '',
  sku_type: '',
  quantity_in_unit_of_measure: '',
  unit_of_measure: '',
};

const validationSchema = Yup.object().shape({
  day_of_week: Yup.string().required('Required'),
  sku_type: Yup.string().required('Required'),
  unit_of_measure: Yup.string().required('Required'),
  quantity_in_unit_of_measure: Yup.string()
    .required('Required')
    .transform((value) => (parseInt(value) <= 0 ? NaN : value))
    .typeError('Incorrect input'),
});

export default Manage;
